import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Modal,
  Grid,
  Stack,
  Pagination,
  FormControl,
  InputAdornment,
  IconButton,
} from "@mui/material";

import PurchaseItemsCards from "./PurchaseItemsCards";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { convertDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";

import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
} from "../../utils/commonUtils";
import { totalPrice } from "../purchase/purFunction";
import { ToDate } from "../../common/toDate";
import PoprchModal from "../payment/popSearch";
import VendorSearchModal from "./VendorSearchModal";
import { addPurchaseOrderFunction } from "./PurchaseOrderCustomApiHandler";
import { addPurchaseOrder } from "./PurchaseOrderApi.js";
import { updatePurchase } from "./purchaseManagmentApi.js";
import { useSelector } from "react-redux";
import { forIn } from "lodash";
import calendar from "../../assets/icon/calendarblack.png";

export default function AddPuchaseOrder({
  modaldata,
  open,
  setOpen,
  setModalData,
  getAllData,
}) {
  //   const [pagination, setPagination] = useState({ page: 1, total: 10 });
  // const [search, setSearch] = useState("");

  const struct = {
    // id: 0,
    vendorId: 0,
    date: "",
    validTill: "",
    totalAmount: 0,
    purchaseItems: [],
  };
  const [formData, setFormData] = useState({ ...struct });

  const purchaseItemStruct = {
    itemDescription: "",
    quantity: "",
    unitPrice: "",
    cgst: "",
    sgst: "",
    igst: "",
    subTotal: "",
    cgstAmount: "",
    sgstAmount: "",
    igstAmount: "",
    total: "",
  };

  const [purchaseItem, setPurchaseItem] = useState(purchaseItemStruct);

  const onClose = () => {
    setOpen(false);
    setAddItemError({ ...AddItemErrorStruct });
    setFormData({ ...struct });
  };

  const validateForm = () => {
    if (
      formData.vendorId &&
      formData.date &&
      formData.validTill &&
      formData.purchaseItems.length > 0
    ) {
      return true;
    } else {
      if (!formData.vendorId) {
        Swal.fire({
          title: "Select Vendor",
          icon: "warning",

          ...swalAlertPopProps,
        });
      } else if (!formData.date) {
        Swal.fire({
          title: "Select Date",
          icon: "warning",

          ...swalAlertPopProps,
        });
      } else if (!formData.validTill) {
        Swal.fire({
          title: "Select Valid Till Date",
          icon: "warning",

          ...swalAlertPopProps,
        });
      } else if (!formData.purchaseItems.length > 0) {
        Swal.fire({
          title: "Add Purchase Items",
          icon: "warning",

          ...swalAlertPopProps,
        });
      }
    }
  };

  const [AddItemError, setAddItemError] = useState({
    itemDescription: false,
    quantity: false,
    unitPrice: false,
  });

  const AddItemErrorStruct = {
    itemDescription: false,
    quantity: false,
    unitPrice: false,
  };

  const validateItem = () => {
    const { itemDescription, quantity, unitPrice, cgst, sgst, igst } =
      purchaseItem;
    let newErrors = { ...AddItemErrorStruct };
    let isValid = true;

    if (!itemDescription) {
      newErrors.itemDescription = true;
      isValid = false;
    }
    if (!quantity) {
      newErrors.quantity = true;
      isValid = false;
    }
    if (!unitPrice) {
      newErrors.unitPrice = true;
      isValid = false;
    }

    const cgstVal = parseFloat(cgst || 0);
    const sgstVal = parseFloat(sgst || 0);
    const igstVal = parseFloat(igst || 0);

    if (cgstVal > 0 && sgstVal > 0 && cgstVal !== sgstVal) {
      Swal.fire({
        icon: "error",
        text: "CGST and SGST must have equal % values",
        ...swalAlertPopProps,
      });
      newErrors.cgst = true;
      newErrors.sgst = true;
      isValid = false;
    }

    setAddItemError(newErrors);

    return isValid;
  };

  const userDetail = useSelector((state) => state.reducer.userDetail);

  useEffect(() => {
    if (modaldata && open) {
      let obj = {};
      Object.keys(struct).map((key, index) => {
        obj[key] = modaldata[key];
      });
      console.log("modalData d=== ", modaldata);
      setFormData({
        ...modaldata,
        purchaseItems: modaldata?.purchaseItems,
        totalAmount: modaldata?.totalAmount,
        vendorId: modaldata?.vendorId,
        id: modaldata?.id,
        validTill: modaldata?.validTill,
      });
      setSearchvalue(modaldata?.vendorName);
      setCardValue({
        vendorId: modaldata?.vendorId,
        vendorName: modaldata?.vendorName,
      });
    } else {
      setFormData({ ...struct });
      // setSearchvalue(:)
      setModalData(null);
      setPurchaseItem({ ...purchaseItemStruct });
      setCardValue(null);
      setSearchvalue("");
    }
  }, [open]);
  useEffect(() => {
    console.log("formDataformData== ", formData);
  }, [formData]);

  const [searchModal, setSearchModal] = useState(false);

  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);
  const [search, setSearchvalue] = useState("");
  const [cardValue, setCardValue] = useState({});

  const [startDateFormat, setstartDateFormat] = useState(
    getFirstDateOfCurrentMonthPayloadFormate()
  );

  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    const qty = Number(purchaseItem.quantity || 0);
    const price = Number(purchaseItem.unitPrice || 0);
    const cgst = parseFloat(purchaseItem.cgst || 0);
    const sgst = parseFloat(purchaseItem.sgst || 0);
    const igst = parseFloat(purchaseItem.igst || 0);

    const subTotal = qty * price;
    const cgstAmount = (subTotal * cgst) / 100;
    const sgstAmount = (subTotal * sgst) / 100;
    const igstAmount = (subTotal * igst) / 100;
    const total = subTotal + cgstAmount + sgstAmount + igstAmount;

    setPurchaseItem((prev) => ({
      ...prev,
      subTotal: subTotal.toFixed(2),
      cgstAmount: cgstAmount.toFixed(2),
      sgstAmount: sgstAmount.toFixed(2),
      igstAmount: igstAmount.toFixed(2),
      total: total.toFixed(2),
    }));
  }, [
    purchaseItem.quantity,
    purchaseItem.unitPrice,
    purchaseItem.cgst,
    purchaseItem.sgst,
    purchaseItem.igst,
  ]);

  // useEffect(()=>{
  //     setFormData((prev)=>{
  //         let t={...prev}
  //         return {...t, totalAmount:parseFloat( totalPrice(formData.purchaseItems))}
  //     })
  // },[formData])

  useEffect(() => {
    console.log("purchase data businessChooseTab?.value", userDetail);
    if (userDetail && userDetail?.profileId) {
      let val = userDetail?.profileId?.split("?")[1];

      setFormData((prev) => {
        let t = { ...prev };
        return {
          ...t,
          totalAmount: parseFloat(totalPrice(formData.purchaseItems)),
          // billerId:val.split("=")[1]?.replace(/\D/g, "") ,
        };
      });
    }
  }, [userDetail]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "60%", lg: "55%" },

          overflowY: "auto",
          height: { xs: "80vh", sm: "75vh", md: "78vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "25%", lg: "30%", xl: "30%" },

          top: { sm: "8%", xs: "3%" },
        }}
      >
        <ModalHeader
          title={"Purchase Order"}
          onClose={(data) => {
            setOpen(data);
            setAddItemError({ ...AddItemErrorStruct });
          }}
        />
        <Grid container sx={{ position: "relative", p: 2 }}>
          <Grid container item xs={12} spacing={2} sx={{}}>
            <Grid item xs={12} sm={4} sx={{}}>
              <Box
                readonly
                fullWidth
                onClick={() => {
                  setSearchOutStandingsModal(true);
                }}
                sx={{
                  //   mt: "12px",
                  display: "flex",
                  //   height: "23px",
                  justifyContent: "space-between",
                  // width: "70%",
                  border: "1px solid #01008BA8",
                  p: 1,
                  borderRadius: "4px ",
                  fontFamily: "Montserrat",
                  color: "#545454",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  "&:hover": {
                    cursor: "pointer !important",
                  },
                }}
                onChange={(e) => {
                  // setSearch(e.target.value);
                }}
              >
                <Typography
                  variant="p"
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                >
                  {search !== "" ? search : "Select Vendor :"}
                </Typography>
                <SearchIcon
                  onClick={() => {
                    setSearchOutStandingsModal(true);
                  }}
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date :"
                    value={formData?.date ? dayjs(formData.date) : null}
                    onChange={(newValue) => {
                      console.log(newValue);
                      let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                      setFormData({ ...formData, date: formattedDate });
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        InputLabelProps: {
                          className: "mulish",
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        },
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          classes: { input: "mulish" },
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Valid Till :"
                    size="small"
                    value={
                      formData?.validTill ? dayjs(formData.validTill) : null
                    }
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    onChange={(newValue) => {
                      console.log(newValue);
                      let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                      setFormData({ ...formData, validTill: formattedDate });
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        InputLabelProps: {
                          className: "mulish",
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        },
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          classes: {
                            input: "mulish",
                          },
                          sx: {
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                sx={{ width: "100%" }}
                label="Item Description"
                size="small"
                required
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  classes: { input: "mulish" },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                value={purchaseItem?.itemDescription}
                onChange={(e) => {
                  setAddItemError({
                    ...AddItemError,
                    itemDescription: false,
                  });
                  setPurchaseItem({
                    ...purchaseItem,
                    itemDescription: e.target.value,
                  });
                }}
              />
              {AddItemError.itemDescription && (
                <Typography
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                  variant="caption"
                  color="red"
                >
                  Item Description is Required
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                type="text"
                size="small"
                label="Qty"
                sx={{ width: "100%" }}
                value={purchaseItem?.quantity}
                required
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                onChange={(e) => {
                  setAddItemError({ ...AddItemError, quantity: false });
                  setPurchaseItem({
                    ...purchaseItem,
                    quantity: Number(e.target.value),
                  });
                }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
              />
              {AddItemError.quantity && (
                <Typography
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                  variant="caption"
                  color="red"
                >
                  Quantity is Required
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                type="text"
                size="small"
                sx={{ width: "100%" }}
                label="Unit Price"
                required
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                value={purchaseItem?.unitPrice}
                onChange={(e) => {
                  setAddItemError({ ...AddItemError, unitPrice: false });
                  setPurchaseItem({
                    ...purchaseItem,
                    unitPrice: Number(e.target.value),
                  });
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  },
                }}
              />
              {AddItemError.unitPrice && (
                <Typography
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                  variant="caption"
                  color="red"
                >
                  Unit Price is Required
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                label="CGST(%)"
                // onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))}
                value={purchaseItem?.cgst}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  classes: { input: "mulish" },
                  readOnly: !!purchaseItem.igst,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                // InputProps={{ readOnly: !!purchaseItem.igst }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setPurchaseItem({
                      ...purchaseItem,
                      cgst: val,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                label="SGST(%)"
                // onInput={(e) =>
                //   (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                // }
                value={purchaseItem?.sgst}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  classes: { input: "mulish" },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                  readOnly: !!purchaseItem.igst,
                }}
                // InputProps={{}}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setPurchaseItem({
                      ...purchaseItem,
                      sgst: val,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                sx={{ width: "100%" }}
                label="IGST(%)"
                size="small"
                // onInput={(e) =>
                //   (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                // }
                value={purchaseItem?.igst}
                // InputProps={{}}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  classes: { input: "mulish" },
                  readOnly: !!purchaseItem.cgst || !!purchaseItem.sgst,
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setPurchaseItem({
                      ...purchaseItem,
                      igst: val,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3} sx={{}}>
              <TextField
                type="number"
                size="small"
                sx={{ width: "100%" }}
                label="Sub Total"
                value={purchaseItem?.total}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={3} sx={{ p: "14px" }}>
              <Button
                sx={{
                  width: "100%",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                variant="contained"
                onClick={() => {
                  if (validateItem()) {
                    const qty = purchaseItem.quantity;
                    const price = purchaseItem.unitPrice;
                    const cgstPercent = parseFloat(purchaseItem.cgst || 0);
                    const sgstPercent = parseFloat(purchaseItem.sgst || 0);
                    const igstPercent = parseFloat(purchaseItem.igst || 0);

                    const baseAmount = qty * price;
                    const cgstAmount = (baseAmount * cgstPercent) / 100;
                    const sgstAmount = (baseAmount * sgstPercent) / 100;
                    const igstAmount = (baseAmount * igstPercent) / 100;
                    const total =
                      baseAmount + cgstAmount + sgstAmount + igstAmount;

                    const finalItem = {
                      ...purchaseItem,
                      quantity: qty,
                      unitPrice: price,
                      subTotal: baseAmount,
                      cgst: cgstPercent,
                      sgst: sgstPercent,
                      igst: igstPercent,
                      cgstAmount,
                      sgstAmount,
                      igstAmount,
                      total,
                    };

                    setFormData((prev) => ({
                      ...prev,
                      purchaseItems: [...prev.purchaseItems, finalItem],
                    }));

                    setPurchaseItem({ ...purchaseItemStruct });
                  }
                }}
              >
                Add Item
              </Button>
            </Grid>
          </Grid>
          <Divider
            sx={{
              border: "1px solid #01008B",
              width: "100%",
              mt: 1,
            }}
          />
          {/* <Grid
            item
            xs={0.5}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Box style={{ borderBottom: "1px solid #ccc", height: "100%" }} />
          </Grid> */}

          <Grid item xs={12} sx={{ pr: 0 }}>
            <Box
              sx={{
                height: "30vh",
                overflowY: "auto",
                mt: 1,
                px: 1,
                pt: 1,
              }}
            >
              {" "}
              <Box
                sx={{
                  overflowX: { xs: "auto", md: "auto", lg: "auto", sm: "auto" }, // Scroll on mobile only
                }}
              >
                {/* ✅ FIXED MIN WIDTH TO ALLOW HORIZONTAL SCROLL */}
                <Box
                  sx={{ minWidth: { xs: "800px", sm: "800px", md: "800px" } }}
                >
                  <PurchaseItemsCards
                    items={formData?.purchaseItems}
                    arr={formData}
                    setFormData={setFormData}
                  />{" "}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                // padding: "20px"
                px: { sm: 10, xs: 2 },
                py: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Total Amount:
              </Typography>
              <Box
                component="span"
                // sx={{
                //   color: (theme) => theme.palette.secondary.main,
                // }}
                sx={{
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                {" "}
                <CurrencyRupeeIcon
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: "600",
                  }}
                />
                {totalPrice(formData.purchaseItems)}
              </Box>
            </Box>

            <Divider
              sx={{
                borderBottom: "0.5px solid #01008B",
                width: "100%",
                mb: 1,
              }}
            />

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              <Button
                variant="contained"
                fullWidth
                sx={{
                  width: "60%",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onClick={async () => {
                  if (validateForm()) {
                    const payload = {
                      ...formData,
                      totalAmount: parseFloat(
                        totalPrice(formData.purchaseItems)
                      ),
                      date: dayjs(formData.date).format("YYYY-MM-DD"),
                      validTill: dayjs(formData.validTill).format("YYYY-MM-DD"),
                    };

                    const handleResponse = (res) => {
                      if (res?.data?.succeeded) {
                        Swal.fire({
                          title: modaldata
                            ? "Purchase Updated Successfully"
                            : "Purchase Added Successfully",
                          icon: "success",
                          ...swalAlertPopProps,
                        });

                        getAllData();
                        setOpen(false);
                      } else {
                        Swal.fire({
                          title:
                            res?.data?.message ||
                            "Failed to save purchase order",
                          icon: "error",
                          ...swalAlertPopProps,
                        });
                      }

                      setFormData({ ...struct });
                    };

                    if (modaldata) {
                      await updatePurchase(payload, handleResponse).catch(
                        (err) => {
                          Swal.fire({
                            title: "Update failed",
                            text:
                              err?.response?.data?.message ||
                              err.message ||
                              "API error",
                            icon: "error",
                            ...swalAlertPopProps,
                          });
                        }
                      );
                    } else {
                      await addPurchaseOrderFunction(
                        addPurchaseOrder,
                        payload,
                        handleResponse
                      );
                    }
                  }
                }}
              >
                {modaldata ? "Update" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <VendorSearchModal
          cardValue={cardValue}
          setCardValue={(data) => {
            setSearchvalue(data?.vendorName);
            console.log("id id id== ", data);
            setCardValue(data);
            setFormData({ ...formData, vendorId: data?.id });
          }}
          callback={() => {}}
          searchModal={!!searchOutStandingsModal} // Ensure it's a boolean
          setSearchModal={setSearchOutStandingsModal} // Ensure proper function
        />
      </Box>
    </Modal>
  );
}
